module.exports = __webpack_public_path__ + "static/media/icon_checkinrecords.24259562.svg";